import { transparentPagesNames } from '@/utils/headerTheme'

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const { setCustomPageTheme, setTemporaryTheme, setRoute } =
    useHeaderNavigation()
  const { isLp } = useDestination()

  const routeName = computed(() => getRouteName(route))

  nuxtApp.hook('page:finish', () => {
    if (routeName.value) {
      const color =
        (routeName.value === 'destination-name' && isLp.value) ||
        transparentPagesNames.includes(routeName.value)
          ? 'transparent'
          : 'white'

      setRoute(routeName.value)
      setTemporaryTheme(color)
      setCustomPageTheme(color)
    }
  })
})
